import { render, staticRenderFns } from "./SectionEvent.vue?vue&type=template&id=79e619ab&"
import script from "./SectionEvent.vue?vue&type=script&lang=js&"
export * from "./SectionEvent.vue?vue&type=script&lang=js&"
import style0 from "./SectionEvent.vue?vue&type=style&index=0&id=79e619ab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports